import axiosClient from 'utils/axios';

const endPoint = '/auth';

export default {
  async loginIntranet(payload) {
    const { email, password } = payload;

    const path = `${endPoint}/login-intranet`;

    const response = await axiosClient.post(path, { email, password });

    return response.data;
  },

  async loginExtranet(payload) {
    const { email, password } = payload;

    const path = `${endPoint}/login-extranet`;

    const response = await axiosClient.post(path, { email, password });

    return response.data;
  },

  async refreshToken(payload) {
    const { refreshToken } = payload;

    const path = `${endPoint}/token`;

    const response = await axiosClient.post(`${path}`, { refreshToken });

    return response.data;
  },

  async register(payload) {
    const { registerData } = payload;

    const path = `${endPoint}/register`;

    const response = await axiosClient.post(path, registerData);

    return response.data;
  },

  async forgotPassword(payload) {
    const { passwordData } = payload;

    const path = `${endPoint}/forgot-password`;

    const response = await axiosClient.post(path, passwordData);

    return response.data;
  },

  async forgotPasswordExtranet(payload) {
    const { email } = payload;

    const path = `${endPoint}/forgot-password-extranet`;

    const response = await axiosClient.post(path, { email });

    return response.data;
  },

  async verifyCodeExtranet(payload) {
    const { code, email } = payload;

    const path = `${endPoint}/verify-code-extranet`;

    const response = await axiosClient.post(path, { code, email });

    return response.data;
  },

  async resetPasswordExtranet(payload) {
    const {
      email,
      code,
      password,
      confirmPassword,
    } = payload;

    const path = `${endPoint}/reset-password-extranet`;

    const response = await axiosClient.post(path, {
      email,
      code,
      password,
      confirmPassword,
    });

    return response.data;
  },
};
